var map = {
	"./bg_loader.png": 5917,
	"./character/img_airou.png": 1900,
	"./character/img_chunli.png": 7835,
	"./character/img_chunli02.png": 4249,
	"./character/img_gutsman.png": 8213,
	"./character/img_mettaur.png": 6718,
	"./character/img_mettaur01.png": 2447,
	"./character/img_mettaur02.png": 7956,
	"./character/img_rockman.png": 1765,
	"./character/img_rockman02.png": 1959,
	"./character/img_ryu.png": 7860,
	"./common/bg_check_blue.png": 8003,
	"./common/bg_check_white.png": 1072,
	"./common/bg_check_yellow.png": 4127,
	"./common/bg_form.png": 8282,
	"./common/bg_form_title.png": 8597,
	"./common/bg_form_title_sp.png": 7727,
	"./common/bg_line_blue.svg": 2052,
	"./common/bg_line_white.svg": 7983,
	"./common/bg_logout.svg": 7145,
	"./common/bg_triangle_blue.png": 4973,
	"./common/bg_triangle_blue02.png": 1759,
	"./common/ico_check_blue.svg": 9568,
	"./common/icon_scroll_hint.svg": 5010,
	"./common/img_device_landscape.png": 2778,
	"./common/img_yellow_deco.png": 6160,
	"./common/logo.png": 2855,
	"./common/logo_corporate.png": 1187,
	"./common/logo_header.svg": 1632,
	"./common/text_off_white.svg": 6208,
	"./common/text_on_white.svg": 1138,
	"./common/text_playgame.svg": 1891,
	"./common/title_modal.svg": 3171,
	"./detail/controller-button_a.png": 9521,
	"./detail/controller-button_b.png": 4762,
	"./detail/controller-button_down.png": 4126,
	"./detail/controller-button_l.png": 8644,
	"./detail/controller-button_left.png": 5565,
	"./detail/controller-button_r.png": 8026,
	"./detail/controller-button_right.png": 4798,
	"./detail/controller-button_select.png": 3074,
	"./detail/controller-button_start.png": 1392,
	"./detail/controller-button_up.png": 5041,
	"./detail/controller-button_x.png": 3760,
	"./detail/controller-button_y.png": 9,
	"./detail/controller_nes.png": 3845,
	"./detail/controller_snes.png": 32,
	"./emulator/img_device.png": 4922,
	"./emulator/img_mettaur.png": 5300,
	"./faq/img_a.png": 6476,
	"./faq/img_q.png": 9692,
	"./game/bg_hero_bottom.png": 1955,
	"./game/ogp_classicgames_top_en.png": 4183,
	"./game/ogp_classicgames_top_ja.png": 2137,
	"./game/ogp_classicgames_top_pt_br.png": 7247,
	"./heading/img_1player.png": 145,
	"./heading/img_2player.png": 5946,
	"./heading/img_controls.png": 7489,
	"./heading/img_faq.png": 2463,
	"./heading/img_game-rule.png": 7526,
	"./heading/img_manual.png": 1053,
	"./heading/img_playable-games.png": 6879,
	"./heading/img_select-a-controller.png": 2436,
	"./heading/img_share.png": 3990,
	"./heading/img_share_main.png": 4364,
	"./heading/img_various-heading.png": 3169,
	"./heading/img_various-services.png": 8347,
	"./icon/angle-circle/ico-angle-circle_white.svg": 4078,
	"./icon/angle/ico_angle_black.svg": 196,
	"./icon/angle/ico_angle_black02.svg": 5094,
	"./icon/angle/ico_angle_blue.svg": 1127,
	"./icon/angle/ico_angle_down.svg": 9567,
	"./icon/angle/ico_angle_down_blue.svg": 3474,
	"./icon/angle/ico_angle_down_white.svg": 1225,
	"./icon/angle/ico_angle_up_white02.svg": 4795,
	"./icon/angle/ico_angle_white.svg": 4354,
	"./icon/angle/ico_angle_white02.svg": 4752,
	"./icon/arrow/ico_arrow_blue.svg": 2835,
	"./icon/arrow/ico_arrow_gray.svg": 6610,
	"./icon/arrow/ico_arrow_right_white.svg": 5621,
	"./icon/arrow/ico_arrow_white.svg": 1878,
	"./icon/back/ico_back_blue.svg": 9179,
	"./icon/check/ico_check_blue.svg": 4779,
	"./icon/check/ico_check_white.svg": 8174,
	"./icon/close/ico_close_black.svg": 8416,
	"./icon/close/ico_close_black02.svg": 6418,
	"./icon/close/ico_close_white.svg": 958,
	"./icon/controller/ico_controller_blue.svg": 7537,
	"./icon/exit/ico_exit_white.svg": 7468,
	"./icon/external/ico_external_black.svg": 6936,
	"./icon/external/ico_external_blue.svg": 3427,
	"./icon/external/ico_external_disabled.svg": 7235,
	"./icon/external/ico_external_white.svg": 8966,
	"./icon/game/ico_cassette.svg": 20,
	"./icon/game/ico_controller.svg": 40,
	"./icon/game/ico_full-screen_off.svg": 1194,
	"./icon/game/ico_full-screen_on.svg": 6868,
	"./icon/game/ico_help.svg": 9889,
	"./icon/game/ico_manual.svg": 3946,
	"./icon/game/ico_return.svg": 5202,
	"./icon/location/ico_location_white.svg": 7286,
	"./icon/lock/ico_lock.svg": 8516,
	"./icon/lock/ico_lock_yellow.svg": 4375,
	"./icon/login/ico_login.svg": 5772,
	"./icon/login/ico_login_color.png": 6987,
	"./icon/menu/ico_menu_close.svg": 9677,
	"./icon/menu/ico_menu_open.svg": 9975,
	"./icon/movie/ico_movie.svg": 6828,
	"./icon/movie/ico_movie02_blue.svg": 7553,
	"./icon/new/ico_new.svg": 4640,
	"./icon/new/ico_new_mini.svg": 2734,
	"./icon/new/ico_new_tag_red.svg": 9497,
	"./icon/new/ico_new_tag_red_es_us.svg": 7987,
	"./icon/new/ico_new_tag_red_kr.svg": 7583,
	"./icon/new/ico_new_tag_red_pt_br.svg": 2903,
	"./icon/new/ico_new_tag_red_sc.svg": 4774,
	"./icon/new/ico_new_tag_red_tc.svg": 3115,
	"./icon/new/ico_new_tag_red_th.svg": 4992,
	"./icon/new/ico_new_yellow.svg": 8667,
	"./icon/notice/ico_notice_blue.svg": 181,
	"./icon/pin/ico_pin_balloon_blue.svg": 3543,
	"./icon/pin/ico_pin_balloon_red.svg": 236,
	"./icon/pin/ico_pin_blue.svg": 9947,
	"./icon/play/ico_play.svg": 8278,
	"./icon/share/ico_share_black.svg": 1764,
	"./icon/share/ico_share_blue.svg": 8471,
	"./icon/share/ico_share_white.svg": 4642,
	"./icon/sns/ico_facebook.svg": 5582,
	"./icon/sns/ico_line.svg": 8004,
	"./icon/sns/ico_reddit.svg": 5594,
	"./icon/sns/ico_twitter.svg": 6523,
	"./icon/sns/ico_url.svg": 5437,
	"./icon/sns/ico_url_blue.svg": 8220,
	"./icon/sns/ico_url_white.svg": 1111,
	"./icon/sns/ico_weibo.svg": 4502,
	"./icon/sns/ico_x.svg": 7614,
	"./icon/sound/ico_sound_off.svg": 5794,
	"./icon/sound/ico_sound_on.svg": 3164,
	"./icon/user/ico_user_blue.svg": 8947,
	"./icon/user/ico_user_white.svg": 1798,
	"./logo-capcom.png": 3606,
	"./logo-sp.png": 9847,
	"./logo.png": 4579,
	"./news/bg_board.png": 3972,
	"./news/bg_news.jpg": 4111,
	"./news/bg_news_sp.jpg": 6421,
	"./news/bg_paper_blue01.png": 1554,
	"./news/bg_paper_blue02.png": 7641,
	"./news/bg_paper_yellow01.png": 1630,
	"./news/bg_paper_yellow02.png": 7381,
	"./news/bg_shadow.png": 6310,
	"./news/bg_texture.png": 2057,
	"./news/bg_title_bottom.png": 7778,
	"./news/bg_title_point.svg": 8262,
	"./news/bg_title_side.png": 8050,
	"./news/bg_title_side_sp.png": 4558,
	"./news/img_tape_blue.png": 1849,
	"./news/img_tape_orange.png": 7723,
	"./news/ogp.png": 8148,
	"./play/bg_play.jpg": 2015,
	"./play/btn_a.png": 7893,
	"./play/btn_b.png": 5790,
	"./play/btn_cross.png": 5687,
	"./play/btn_l.png": 9856,
	"./play/btn_r.png": 3278,
	"./play/btn_select.png": 4782,
	"./play/btn_start.png": 4052,
	"./play/btn_x.png": 324,
	"./play/btn_y.png": 7005,
	"./souvenir/souvenir_01.jpg": 7927,
	"./souvenir/souvenir_02.jpg": 3704,
	"./theater/01_SF.png": 3493,
	"./theater/02_megaman.png": 9489,
	"./theater/03_PRAGMATA.png": 8537,
	"./theater/04_RE9.png": 441,
	"./theater/05_Dragon's_Dogma_2.png": 3823,
	"./theater/06_ss.png": 7881,
	"./theater/07_ace.png": 1183,
	"./theater/08_SLASH.png": 8577,
	"./theater/09_MH.png": 9921,
	"./theater/10_Reborn.png": 4670,
	"./theater/bg_film.svg": 79,
	"./theater/bg_new.svg": 5537,
	"./theater/bg_theater-all.jpg": 3697,
	"./theater/bg_theater-all_sp.jpg": 4859,
	"./theater/bg_theater01.png": 278,
	"./theater/bg_theater01_sp.png": 3714,
	"./theater/bg_theater02.png": 7693,
	"./theater/bg_theater02_sp.png": 2839,
	"./theater/border_dot_yellow.png": 4879,
	"./theater/capcom-store_banner.png": 8634,
	"./theater/e-capcom_banner.png": 1432,
	"./theater/ogp_theater_top_en.png": 9798,
	"./theater/ogp_theater_top_ja.png": 5112,
	"./theater/ogp_theater_top_pt_br.png": 244,
	"./top/landing/bg_landing_pc.svg": 9580,
	"./top/landing/bg_landing_sp.svg": 5754,
	"./top/landing/ico_mute_black.svg": 7440,
	"./top/landing/ico_mute_white.svg": 9982,
	"./top/landing/ico_sound_black.svg": 9632,
	"./top/landing/ico_sound_white.svg": 9566,
	"./top/landing/img_castle_01.svg": 501,
	"./top/landing/img_castle_02.svg": 8726,
	"./top/landing/img_cloud_01.svg": 2026,
	"./top/landing/img_cloud_02.svg": 4377,
	"./top/landing/img_kobun.svg": 338,
	"./top/landing/img_rathalos_01.svg": 411,
	"./top/landing/img_rathalos_02.svg": 1576,
	"./top/landing/img_sonson.svg": 3553,
	"./top/landing/img_truck.svg": 9014,
	"./top/landing/img_truck_02.svg": 279,
	"./top/landing/img_vega.svg": 7182,
	"./top/landing/logo_40th.png": 1668,
	"./top/landing/logo_capcom_town.png": 12,
	"./top/landing/text_off_black.svg": 5102,
	"./top/landing/text_off_white.svg": 7604,
	"./top/landing/text_on_black.svg": 6680,
	"./top/landing/text_on_white.svg": 8390,
	"./top/map/map_amusement.png": 4915,
	"./top/map/map_arcade.png": 3978,
	"./top/map/map_bio.png": 3118,
	"./top/map/map_capcom-id.png": 6071,
	"./top/map/map_capcom_town_store.png": 6352,
	"./top/map/map_captore.png": 9572,
	"./top/map/map_corporate.png": 1737,
	"./top/map/map_devil-may-cry.png": 3173,
	"./top/map/map_e-capcom.png": 7799,
	"./top/map/map_esports.png": 3696,
	"./top/map/map_game.png": 5332,
	"./top/map/map_monster-hunter.png": 9263,
	"./top/map/map_news.png": 1879,
	"./top/map/map_street-fighter.png": 5231,
	"./top/map/map_theater.png": 7383,
	"./top/ogp.png": 994,
	"./top/opening/bg_map_blur.jpg": 5715,
	"./top/opening/bg_sky_pc.png": 5400,
	"./top/opening/bg_sky_sp.png": 2450,
	"./top/opening/img_airou.png": 4349,
	"./top/opening/img_all_characters.png": 7605,
	"./top/opening/img_all_characters@2x.png": 7327,
	"./top/opening/img_balloon_pc.png": 5194,
	"./top/opening/img_balloon_sp.png": 9020,
	"./top/opening/img_bar_text_pc.svg": 1883,
	"./top/opening/img_bar_text_sp.svg": 9873,
	"./top/opening/img_building.png": 4041,
	"./top/opening/img_building_results.png": 9706,
	"./top/opening/img_cloud_01.png": 1210,
	"./top/opening/img_cloud_02.png": 1105,
	"./top/opening/img_cloud_03.png": 9064,
	"./top/opening/img_cloud_04.png": 8679,
	"./top/opening/img_cloud_05.png": 6542,
	"./top/opening/img_cloud_06.png": 3269,
	"./top/opening/img_makaimura.png": 4491,
	"./top/opening/img_plane.png": 8359,
	"./top/opening/img_pop_effect.svg": 9313,
	"./top/opening/img_rathalos.png": 2095,
	"./top/opening/img_sonson.png": 2349,
	"./top/opening/img_vega.png": 5566,
	"./top/opening/text_thanks_pc.svg": 2503,
	"./top/opening/text_thanks_sp.svg": 4653,
	"./top/top_modal/img_character_04_01.png": 1328,
	"./top/top_modal/img_character_04_01_sp.png": 5936,
	"./top/top_modal/img_character_04_02.png": 2539,
	"./top/top_modal/img_character_04_02_sp.png": 1313,
	"./top/top_modal/img_character_pin_elections.png": 4186,
	"./top/top_modal/img_character_pin_museum.png": 9276,
	"./top/top_modal/img_character_tab1_01.png": 4550,
	"./top/top_modal/img_character_tab1_02.png": 5757,
	"./top/top_modal/img_character_tab2_01.png": 5467,
	"./top/top_modal/img_character_tab2_02.png": 7136,
	"./top/top_modal/img_character_tab3_01.png": 4092,
	"./top/top_modal/img_character_tab3_02.png": 4727,
	"./top/top_modal/img_characters.png": 8756,
	"./top/top_modal/img_characters_sp.png": 1636,
	"./top/top_modal/img_introduction_01_pc.jpg": 9226,
	"./top/top_modal/img_introduction_01_pc_de.jpg": 3774,
	"./top/top_modal/img_introduction_01_pc_en.jpg": 6,
	"./top/top_modal/img_introduction_01_pc_es.jpg": 3415,
	"./top/top_modal/img_introduction_01_pc_fr.jpg": 1147,
	"./top/top_modal/img_introduction_01_pc_it.jpg": 72,
	"./top/top_modal/img_introduction_01_pc_ja.jpg": 5664,
	"./top/top_modal/img_introduction_01_pc_ko.jpg": 6501,
	"./top/top_modal/img_introduction_01_pc_pt-BR.jpg": 7998,
	"./top/top_modal/img_introduction_01_pc_zh-CN.jpg": 1500,
	"./top/top_modal/img_introduction_01_pc_zh-TW.jpg": 6031,
	"./top/top_modal/img_introduction_01_sp.jpg": 5700,
	"./top/top_modal/img_introduction_01_sp_de.jpg": 5288,
	"./top/top_modal/img_introduction_01_sp_en.jpg": 2108,
	"./top/top_modal/img_introduction_01_sp_es.jpg": 7357,
	"./top/top_modal/img_introduction_01_sp_fr.jpg": 1973,
	"./top/top_modal/img_introduction_01_sp_it.jpg": 8482,
	"./top/top_modal/img_introduction_01_sp_ja.jpg": 8366,
	"./top/top_modal/img_introduction_01_sp_ko.jpg": 1071,
	"./top/top_modal/img_introduction_01_sp_pt-BR.jpg": 1908,
	"./top/top_modal/img_introduction_01_sp_zh-CN.jpg": 3593,
	"./top/top_modal/img_introduction_01_sp_zh-TW.jpg": 9629,
	"./top/top_modal/img_introduction_02_pc.jpg": 487,
	"./top/top_modal/img_introduction_02_sp.jpg": 8009,
	"./top/top_modal/img_introduction_03_pc.jpg": 6704,
	"./top/top_modal/img_introduction_03_sp.jpg": 8618,
	"./top/top_modal/img_introduction_04_pc.jpg": 7645,
	"./top/top_modal/img_introduction_04_pc_de.jpg": 9799,
	"./top/top_modal/img_introduction_04_pc_en.jpg": 2595,
	"./top/top_modal/img_introduction_04_pc_es.jpg": 6058,
	"./top/top_modal/img_introduction_04_pc_fr.jpg": 246,
	"./top/top_modal/img_introduction_04_pc_it.jpg": 3309,
	"./top/top_modal/img_introduction_04_pc_ja.jpg": 5725,
	"./top/top_modal/img_introduction_04_pc_ko.jpg": 620,
	"./top/top_modal/img_introduction_04_pc_pt-BR.jpg": 329,
	"./top/top_modal/img_introduction_04_pc_zh-CN.jpg": 9752,
	"./top/top_modal/img_introduction_04_pc_zh-TW.jpg": 8484,
	"./top/top_modal/img_introduction_04_sp.jpg": 8103,
	"./top/top_modal/img_introduction_04_sp_de.jpg": 4545,
	"./top/top_modal/img_introduction_04_sp_en.jpg": 8553,
	"./top/top_modal/img_introduction_04_sp_es.jpg": 6688,
	"./top/top_modal/img_introduction_04_sp_fr.jpg": 3000,
	"./top/top_modal/img_introduction_04_sp_it.jpg": 5471,
	"./top/top_modal/img_introduction_04_sp_ja.jpg": 5931,
	"./top/top_modal/img_introduction_04_sp_ko.jpg": 7974,
	"./top/top_modal/img_introduction_04_sp_pt-BR.jpg": 1599,
	"./top/top_modal/img_introduction_04_sp_zh-CN.jpg": 1682,
	"./top/top_modal/img_introduction_04_sp_zh-TW.jpg": 7282,
	"./top/top_modal/img_introduction_05_pc_en.gif": 9941,
	"./top/top_modal/img_introduction_05_pc_es.gif": 5040,
	"./top/top_modal/img_introduction_05_pc_ja.gif": 9943,
	"./top/top_modal/img_introduction_05_pc_ko.gif": 8142,
	"./top/top_modal/img_introduction_05_pc_pt-br.gif": 5845,
	"./top/top_modal/img_introduction_05_pc_sc.gif": 7490,
	"./top/top_modal/img_introduction_05_pc_tc.gif": 6407,
	"./top/top_modal/img_introduction_05_pc_th.gif": 744,
	"./top/top_modal/img_introduction_05_sp_en.gif": 728,
	"./top/top_modal/img_introduction_05_sp_es.gif": 1606,
	"./top/top_modal/img_introduction_05_sp_ja.gif": 2637,
	"./top/top_modal/img_introduction_05_sp_ko.gif": 8040,
	"./top/top_modal/img_introduction_05_sp_pt-br.gif": 1307,
	"./top/top_modal/img_introduction_05_sp_sc.gif": 988,
	"./top/top_modal/img_introduction_05_sp_tc.gif": 9253,
	"./top/top_modal/img_introduction_05_sp_th.gif": 5570,
	"./top/top_modal/img_introduction_06_en.png": 5897,
	"./top/top_modal/img_introduction_06_ja.png": 7240,
	"./top/top_modal/img_introduction_nav-game.png": 6319,
	"./top/top_modal/img_introduction_nav-store.png": 3798,
	"./top/top_modal/img_introduction_nav-theater.png": 30,
	"./top/top_modal/img_num_1.svg": 541,
	"./top/top_modal/img_num_2.svg": 4270,
	"./top/top_modal/img_num_3.svg": 4319,
	"./top/top_modal/title_elections.svg": 2570,
	"./top/top_modal/title_modal.svg": 4453,
	"./top/top_modal/title_museum.svg": 7178
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1821;